<template>
  <div>
    <div class="header flex-between">
      <div class="header-text">
        <h1>异业券库管理-管理券库</h1>
      </div>
      <div class="header-button">
        <el-button
          icon="iconfont icon-sousuo1"
          class="buttonClass"
          @click="Query"
          >查询</el-button
        >
        <!-- <el-button
          icon="iconfont icon-xiugai1"
          class="buttonClass"
          @click="CouponModuleDownload"
          >券模板下载</el-button
        > -->
        <!-- <el-upload
          action="#"
          class="elUpload"
          ref="UploadImport"
          :show-file-list="false"
          :on-change="ImportCoupon"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          :auto-upload="false"
        > -->
        <el-button
          icon="iconfont icon-xiugai1"
          @click="ImprotExcel"
          class="ParntPosttion buttonClass"
          >导入未核销劵</el-button
        >
        <!-- </el-upload> -->
        <!-- <el-button
          icon="iconfont icon-xiugai1"
          @click="VoucherModuleDownload"
          class="buttonClass buttonClass1"
          >核销劵模板下载
        </el-button> -->
        <!-- <el-upload
          action="#"
          class="elUpload"
          ref="UploadImport"
          :show-file-list="false"
          :on-change="ImportCouponWritten"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          :auto-upload="false"
        > -->
        <el-button
          icon="iconfont icon-xiugai1"
          @click="ImprotExcel1"
          class="ParntPosttion buttonClass"
          >导入已核销劵</el-button
        >
        <el-button
          icon="el-icon-download"
          @click="(downloadShow = true), getDownladList()"
          >下载已/未核销劵导入结果</el-button
        >
        <!-- </el-upload> -->
        <el-button
          icon="iconfont icon-fanhui"
          class="buttonClass"
          @click="backHistory"
          >返回</el-button
        >
      </div>
    </div>
    <el-card shadow="never" style="margin-top: 10px">
      <div>
        <el-descriptions>
          <el-descriptions-item label="券库编号">{{
            DataBean.coupGrpNo
          }}</el-descriptions-item>
          <el-descriptions-item label="券库名称">{{
            DataBean.couponsName
          }}</el-descriptions-item>
          <el-descriptions-item label="券库后台名称">{{
            DataBean.innerCoupName
          }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <div style="margin: 30px 0 30px 0">
        <el-form size="mini" label-width="100px">
          <el-row :gutter="200">
            <el-col :span="8">
              <el-form-item label="劵编号">
                <el-input v-model="page.coupCode"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="状态">
                <el-select style="width: 100%" v-model="page.state">
                  <el-option
                    v-for="(item, index) in StaticList"
                    :key="index"
                    :label="item.label"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-table
        size="small"
        border
        :height="PagesIsMore ? 'calc(100vh - 25rem)' : 'calc(100vh - 23rem)'"
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          background: '#FCFBF2',
          'text-align': 'center',
          color: '#6C6839',
          fontSize: '14px',
        }"
        :cell-style="{ 'text-align': 'center' }"
        ref="multipleTable"
        :data="SecuritiesList"
        tooltip-effect="dark"
        v-el-table-infinite-scroll="PageTouchTheBottom"
        infinite-scroll-disabled="infiniteScrollDisabledIs"
        v-loading="page.Loading"
      >
        <el-table-column type="index" width="50"> </el-table-column>
        <el-table-column prop="coupCode" label="券编号"> </el-table-column>
        <el-table-column prop="coupPwd" label="券密码"> </el-table-column>
        <el-table-column prop="startDate" label="券有效期开始">
        </el-table-column>
        <el-table-column prop="endDate" label="券有效期结束"> </el-table-column>
        <el-table-column prop="createUserName" width="100" label="创建人">
        </el-table-column>
        <el-table-column prop="createTimeStr" label="创建日期">
        </el-table-column>
        <el-table-column prop="updateUserName" width="100" label="最后修改人">
        </el-table-column>
        <el-table-column prop="updateTimeStr" label="最后修改日期">
        </el-table-column>
        <el-table-column prop="stateText" width="100" label="券状态">
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button
              style="border: 0"
              icon="el-icon-edit-outline"
              v-if="[0, 3].includes(scope.row.state)"
              size="mini"
              @click="WriteOff(scope.row)"
              >核销</el-button
            >
            <el-button
              style="border: 0"
              icon="el-icon-circle-close"
              @click="Disable(scope.row)"
              size="mini"
              v-if="[0, 3].includes(scope.row.state)"
              >禁用</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-alert
        v-if="PagesIsMore"
        title="没有更多数据了!"
        type="warning"
        center
        :closable="false"
      >
      </el-alert>
    </el-card>
    <!-- 会员消费等级—会员消费等级调整-导入下载弹窗
    <el-dialog
      title="异业卷库管理-导入未核销劵"
      :visible.sync="defaultisderived"
      :close-on-click-modal="false"
      width="40%"
    >
      <div class="resui">
        <span>成功处理行数: {{ succeedInfo.sucNum }}</span>
        <span>失败处理行数: {{ succeedInfo.errNum }}</span>
        <span
          >处理结果文件:
          <a href="javascript:void(0);">{{ succeedInfo.fileUrl }} </a>
          <el-button
            icon="el-icon-download"
            @click="downfile(succeedInfo.fileUrl)"
            style="margin-left: 10px"
            >下载</el-button
          >
        </span>
      </div>
    </el-dialog> -->

    <!-- 未核销券导入 -->
    <div class="import">
      <el-dialog
        title="未核销券导入"
        :visible.sync="MemberFreezeImport"
        :close-on-click-modal="false"
        width="40%"
      >
        <el-form
          size="mini"
          label-width="225px"
          ref="newUploadForm"
          enctype="multipart/form-data"
        >
          <el-form-item label="选择待导入未核销券文件">
            <div class="flex-start">
              <el-input
                style="width: 300px"
                v-model="filename"
                :readonly="true"
                placeholder="请选择文件名"
              >
              </el-input>
              <el-upload
                class="upload"
                action="#"
                :show-file-list="false"
                :on-change="ImportCoupon"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                :auto-upload="false"
              >
                <el-button style="margin-left: 20px">选择文件</el-button>
              </el-upload>
            </div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button
            icon="iconfont icon-xiugai1"
            class="buttonClass"
            @click="CouponModuleDownload"
            >券模板下载</el-button
          >
        </span>
      </el-dialog>
    </div>
    <!-- 已核销券导入 -->
    <div class="import">
      <el-dialog
        title="已核销券导入"
        :visible.sync="MemberFreezeImportt"
        :close-on-click-modal="false"
        width="40%"
      >
        <el-form
          size="mini"
          label-width="225px"
          ref="newUploadForm"
          enctype="multipart/form-data"
        >
          <el-form-item label="选择待导入已核销券文件">
            <div class="flex-start">
              <el-input
                style="width: 300px"
                v-model="filenamee"
                :readonly="true"
                placeholder="请选择文件名"
              >
              </el-input>
              <el-upload
                class="upload"
                action="#"
                :show-file-list="false"
                :on-change="ImportCouponWritten"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                :auto-upload="false"
              >
                <el-button style="margin-left: 20px">选择文件</el-button>
              </el-upload>
            </div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button
            icon="iconfont icon-xiugai1"
            class="buttonClass"
            @click="VoucherModuleDownload"
            >核销劵模板下载</el-button
          >
        </span>
      </el-dialog>
    </div>
    <!-- 未核销券导入下载弹窗 -->
    <el-dialog
      append-to-body
      width="50%"
      :visible.sync="downloadShow"
      title="下载导入结果"
    >
      <el-table
        size="small"
        class="table-style"
        border
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          background: '#FCFBF2',
          'text-align': 'center',
          color: '#6C6839',
          fontSize: '14px',
        }"
        :cell-style="{ 'text-align': 'center' }"
        ref="multipleTable"
        :data="downloadData"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <!-- v-loading="loading"
        v-el-table-infinite-scroll="load"
        infinite-scroll-disabled="onLoading" -->
        <el-table-column type="index" width="55" label="序号"></el-table-column>
        <el-table-column
          prop="startTime"
          label="导入开始时间"
        ></el-table-column>

        <el-table-column prop="endTime" label="导入结束时间"></el-table-column>

        <el-table-column prop="isComplate" label="状态">
          <template slot-scope="scope">
            {{ scope.row.isComplate ? "完成" : "执行中" }}
          </template>
        </el-table-column>
        <el-table-column prop="startTime" label="下载">
          <template slot-scope="scope">
            <el-button
              icon="el-icon-download"
              v-if="scope.row.isComplate"
              @click="download(scope.row.downloadUrl)"
              >下载</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="downloadShow = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { UploadPictures } from "@/utils/constant";
import { reportFormList } from "@/api/reportForm";
import {
  otherIndustryCouponsList,
  couponsImportCouponsExcel,
  importWriteOffCouponsExcel,
  otherIndustryWriteOff,
  otherIndustryDisable,
} from "@/api/couponsDepot.js";
import { getcpyNo } from "@/utils/auth";
import { mapState } from "vuex";
export default {
  name: "centre",
  data() {
    return {
      downloadData: [],
      downloadShow: false,
      filename: "",
      MemberFreezeImport: false,

      downloadDataa: [],
      downloadShoww: false,
      filenamee: "",
      MemberFreezeImportt: false,

      succeedInfo: {},
      // defaultisderived: false,
      StaticList: [
        {
          label: "全部",
          id: "",
        },
        {
          label: "有效",
          id: "0",
        },
        {
          label: "无效",
          id: "4",
        },
        {
          label: "已核销",
          id: "1",
        },
        {
          label: "已禁用",
          id: "2",
        },
        {
          label: "未发放",
          id: "3",
        },
      ],
      page: {
        //列表请求参数
        pageNo: 1,
        pageSize: 50,
        pages: 2,
        Loading: true,
        coupCode: "",
        state: "",
      },
      DataBean: {
        couponsGrpID: "",
        couponsName: "",
        innerCoupName: "",
      },
      // 默认显示启用按钮
      SecuritiesList: [],
    };
  },
  computed: {
    ...mapState({
      CouponsSelectChang: (state) => state.user.CouponsSelectChang,
    }),
    PagesIsMore() {
      return this.page.pageNo >= this.page.pages;
    },
    infiniteScrollDisabledIs() {
      return this.page.Loading || this.PagesIsMore;
    },
  },
  created() {
    this.RotherIndustryCouponsList();
  },
  methods: {
    //获取下载列表数据
    getDownladList() {
      reportFormList({
        groupName: "核销券",
      }).then((response) => {
        console.log(response);
        this.downloadData = response.data;
      });
    },
    download(src) {
      this.exportShow = false;
      const ele = document.createElement("a");
      ele.style.display = "none";
      ele.href = process.env.VUE_APP_BASE_API + src;
      ele.download = "";
      document.querySelectorAll("body")[0].appendChild(ele);
      ele.click();
      ele.remove();
    },
    //导入未核销
    ImprotExcel() {
      this.MemberFreezeImport = true;
    },
    //导入已核销
    ImprotExcel1() {
      this.MemberFreezeImportt = true;
    },
    Disable(row) {
      let data = require("qs").stringify({
        coupID: row.coupID,
      });
      otherIndustryDisable(data).then((res) => {
        if (res.success) {
          this.$message({
            message: "禁用成功",
            type: "success",
          });
          this.Query();
        }
      });
    },
    WriteOff(row) {
      let data = require("qs").stringify({
        coupID: row.coupID,
      });
      otherIndustryWriteOff(data).then((res) => {
        if (res.success) {
          this.$message({
            message: "核销成功",
            type: "success",
          });
          this.Query();
        }
      });
    },
    VoucherModuleDownload() {
      const ele = document.createElement("a");
      ele.style.display = "none";
      ele.href = `${UploadPictures}/api/templates/已核销异业券模板.xlsx`;
      ele.download = "";
      document.querySelectorAll("body")[0].appendChild(ele);
      ele.click();
      ele.remove();
    },
    downfile(url) {
      const ele = document.createElement("a");
      ele.style.display = "none";
      ele.href = UploadPictures + url;
      ele.download = "";
      document.querySelectorAll("body")[0].appendChild(ele);
      ele.click();
      ele.remove();
    },
    ImportCouponWritten(file) {
      let formData = new FormData();
      formData.append("file", file.raw);
      let parmar = {
        couponsGrpID: this.CouponsSelectChang.couponsGrpID,
      };
      importWriteOffCouponsExcel(formData, parmar).then((res) => {
        if (res.success) {
          this.$message.success("请查看下载导入结果！！");
          this.Query();
          // this.defaultisderived = true;
          this.succeedInfo = res.data;
          this.MemberFreezeImportt = false;
          // this.$refs.UploadImport.clearFiles();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    ImportCoupon(file) {
      let formData = new FormData();
      formData.append("file", file.raw);
      let parmar = {
        couponsGrpID: this.CouponsSelectChang.couponsGrpID,
      };
      couponsImportCouponsExcel(formData, parmar).then((res) => {
        if (res.success) {
          this.$message.success("请查看下载导入结果！！");
          this.Query();
          // this.defaultisderived = true;
          this.succeedInfo = res.data;
          this.MemberFreezeImport = false;
          // this.$refs.UploadImport.clearFiles();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    CouponModuleDownload() {
      const ele = document.createElement("a");
      ele.style.display = "none";
      ele.href = `${UploadPictures}/api/templates/异业券导入模板.xlsx`;
      ele.download = "";
      document.querySelectorAll("body")[0].appendChild(ele);
      ele.click();
      ele.remove();
    },
    returnStateText(index) {
      let text = "";
      switch (index) {
        case 0:
          text = "有效";
          break;
        case 1:
          text = "已核销";
          break;
        case 2:
          text = "已禁用";
          break;
        case 3:
          text = "未发放";
          break;
        case 4:
          text = "无效";
          break;
      }
      return text;
    },
    Query() {
      this.SecuritiesList = [];
      this.page.pageNo = 1;
      this.RotherIndustryCouponsList();
    },
    RotherIndustryCouponsList() {
      let data = require("qs").stringify({
        cpyNo: getcpyNo,
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
        couponsGrpID: this.CouponsSelectChang.couponsGrpID,
        coupCode: this.page.coupCode,
        state: this.page.state,
      });
      otherIndustryCouponsList(data).then((res) => {
        if (res.success) {
          this.DataBean = res.bean;
          this.page.pages = res.data.pages;
          res.data.list.forEach((item) => {
            item.stateText = this.returnStateText(parseInt(item.state));
          });
          this.SecuritiesList = this.SecuritiesList.concat(res.data.list);
        } else {
          this.$message.error(res.message);
        }
        this.page.Loading = false;
      });
    },
    PageTouchTheBottom() {
      //触底了
      this.page.Loading = true;
      this.page.pageNo++;
      this.RotherIndustryCouponsList();
    },
    backHistory() {
      this.$router.go(-1); //返回上一层
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
  },
};
</script>
<style lang="scss" scoped>
.resui {
  display: flex;
  flex-direction: column;
}
.resui span {
  line-height: 30px;
  font-size: 18px;
}
.header-button {
  display: flex;
}

.buttonClass {
  margin-right: 0px !important;
  margin-left: 10px !important;
}
.buttonClass1 {
  margin-left: 30px !important ;
}
.ParntPosttion {
  position: relative;
}
.header-text {
  margin: 20px 0 20px 0;
  color: #76734f;
}
.card-pagination {
  height: 50px;
}
// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}

// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}
// input框的圆角取消
/deep/input {
  border-radius: 0 !important;
}

::v-deep {
  // 改变table里的按钮图标大小
  .table-button .iconfont {
    font-size: 14px;
  }
  // 表格隔行变色
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5 !important;
    color: #ffffff !important;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5 !important;
  }
}
</style>
